import {cgHttp, lcUserHttp} from './index'
import ElementUI, {Message} from "element-ui";

function lcUserRequest(url, method, data) {
    return lcUserHttp({
        url: url,
        method: method,
        data: data
    })
}

function get(url, data) {
    return lcUserRequest(url, 'get', data)
}

function post(url, data) {
    return lcUserRequest(url, 'post', data)
}

export function orderSearch(data) {
    return post('/order/search', data)
}

export function orderRefund(data) {
    return post('/order/refund', data)
}

function requestBuffer(url, method, data) {
    return cgHttp({
        url: url,
        method: method,
        data: data,
        responseType: 'arraybuffer'
    })
}

export function downloadDataLc(url, data, fileName) {
    return requestBuffer(url, 'post', data).then(data => {
        try {
            let enc = new TextDecoder('utf-8')
            let body = JSON.parse(enc.decode(new Uint8Array(data.data)))
            if (body.status !== 0) {
                Message({
                    type: "error",
                    message: body.msg
                });
            }
        } catch (error) {
            console.log(error)
            let blobObject = new Blob([data.data]);
            //是IE浏览器
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            } else {//火狐谷歌都兼容
                //模板中要有一个预定义好的a标签
                let link = document.createElement("a");
                link.href = URL.createObjectURL(blobObject);
                link.download = fileName;
                link.click();
            }
            ElementUI.Message({
                message: '导出Excel成功！',
                type: "success",
            })
        }
    })
}